function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useRef, useEffect, useState } from 'react';
import Drawer from './components/Drawer';
import Home from './pages/Home';
import { ThemeProvider } from '@mui/material';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer';
import { Settings, ProductSelection } from './pages';
import { AuthorizationAPI } from './apis';
import { ConfigProvider } from './components/ConfigContext';
import ErrorBoundary from './components/ErrorBoundary';
import Toast, { handleErrorModal } from './components/Toast';
import { ToastContextProvider } from './components/ToastContext';
import './styles/globals.css';
import { theme } from './styles/theme';
import Product from './pages/Product';
import Cookies from 'js-cookie';
import useBeaconScript from './hooks/useBeaconScript';
import useDocumentTitle from './hooks/useDocumentTitle';
import { useRbacNotifications } from './hooks/useRbacNotifications';
import TermsOfUse from './components/TermsOfUse';
import { ApplicationsProvider } from './components/ApplicationContext';
import { ThemeDetailsProvider } from './components/ThemeDetailsContext';
import HelpCenterGuideViewer from './pages/HelpCenterGuideViewer/HelpCenterGuideViewer';
import { ROUTES } from './constants';
import { PermissionGate } from './components/PermissionGate';
import { ADMIN_ACCESS_ACTIONS, RBAC_ACTIONS } from './utils/permissionGateConfig';
import AccessUnavailable from './pages/AccessUnavailable';
import { clearCache } from './utils/indexedDBCache';
export default function App() {
    var _process$env$REACT_AP;
    var location = useLocation();
    var getAppTitleFromSession = function getAppTitleFromSession(pathname) {
        if (pathname === ROUTES.HOME || pathname === ROUTES.APPS) {
            return 'Converge Experience';
        }
        try {
            var _JSON$parse;
            var currentApp = sessionStorage.getItem('current_application');
            return currentApp ? ((_JSON$parse = JSON.parse(currentApp)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.name) || 'Converge Experience' : 'Converge Experience';
        }
        catch (_unused) {
            return 'Converge Experience';
        }
    };
    var _useState = useState(function () {
        return getAppTitleFromSession(window.location.pathname);
    }), _useState2 = _slicedToArray(_useState, 2), appTitle = _useState2[0], setAppTitle = _useState2[1];
    useEffect(function () {
        setAppTitle(getAppTitleFromSession(location.pathname));
    }, [location.pathname]);
    useBeaconScript(appTitle);
    useDocumentTitle();
    useRbacNotifications();
    var navigate = useNavigate();
    // Check React version compatibility on app initialization
    useEffect(function () {
        // Clear any existing reload counters to prevent stuck reload loops
        sessionStorage.removeItem('mf_reload_count');
        // checkReactVersionCompatibility()
    }, []);
    var timeout = 60 * 60 * 1000; // 1 hour timeout
    var throttle = 10 * 60 * 1000; // 10 minute throttle
    var refreshPromise = null;
    var isFirstAction = useRef(true);
    var performTokenRefresh = /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.n) {
                        case 0:
                            if (!refreshPromise) {
                                refreshPromise = AuthorizationAPI.refreshToken().then(function (result) {
                                    if (result !== null && result !== void 0 && result.accessToken) {
                                        Cookies.set('access_token', result.accessToken, {
                                            secure: true,
                                            sameSite: 'Strict'
                                        });
                                        Cookies.set('refresh_token', result.refreshToken, {
                                            secure: true,
                                            sameSite: 'Strict'
                                        });
                                    }
                                    return result;
                                })["finally"](function () {
                                    refreshPromise = null;
                                });
                            }
                            return _context.a(2, refreshPromise);
                    }
            }, _callee);
        }));
        return function performTokenRefresh() {
            return _ref.apply(this, arguments);
        };
    }();
    var onIdle = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
            var _t, _t2;
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.p = _context2.n) {
                        case 0:
                            handleErrorModal(true, 'You were logged out due to inactivity.');
                            _context2.p = 1;
                            _context2.n = 2;
                            return clearCache();
                        case 2:
                            _context2.n = 4;
                            break;
                        case 3:
                            _context2.p = 3;
                            _t = _context2.v;
                            console.error('Failed to clear IndexedDB cache on idle logout:', _t);
                        case 4:
                            _context2.p = 4;
                            _context2.n = 5;
                            return AuthorizationAPI.logout();
                        case 5:
                            _context2.n = 7;
                            break;
                        case 6:
                            _context2.p = 6;
                            _t2 = _context2.v;
                            console.error('Failed to logout on idle:', _t2);
                        case 7:
                            navigate('/');
                        case 8:
                            return _context2.a(2);
                    }
            }, _callee2, null, [[4, 6], [1, 3]]);
        }));
        return function onIdle() {
            return _ref2.apply(this, arguments);
        };
    }();
    var onAction = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            var result, _t3, _t4, _t5;
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.p = _context3.n) {
                        case 0:
                            if (!isFirstAction.current) {
                                _context3.n = 1;
                                break;
                            }
                            isFirstAction.current = false;
                            return _context3.a(2);
                        case 1:
                            _context3.p = 1;
                            _context3.n = 2;
                            return performTokenRefresh();
                        case 2:
                            result = _context3.v;
                            if (!(result !== null && result !== void 0 && result.accessToken)) {
                                _context3.n = 3;
                                break;
                            }
                            activate(); // reset the idle timer
                            _context3.n = 10;
                            break;
                        case 3:
                            _context3.p = 3;
                            _context3.n = 4;
                            return clearCache();
                        case 4:
                            _context3.n = 6;
                            break;
                        case 5:
                            _context3.p = 5;
                            _t3 = _context3.v;
                            console.error('Failed to clear IndexedDB cache on token refresh failure:', _t3);
                        case 6:
                            _context3.p = 6;
                            _context3.n = 7;
                            return AuthorizationAPI.logout();
                        case 7:
                            _context3.n = 9;
                            break;
                        case 8:
                            _context3.p = 8;
                            _t4 = _context3.v;
                            console.error('Failed to logout after token refresh failure:', _t4);
                        case 9:
                            navigate('/');
                        case 10:
                            _context3.n = 12;
                            break;
                        case 11:
                            _context3.p = 11;
                            _t5 = _context3.v;
                            console.error('Token refresh error:', _t5);
                        case 12:
                            return _context3.a(2);
                    }
            }, _callee3, null, [[6, 8], [3, 5], [1, 11]]);
        }));
        return function onAction() {
            return _ref3.apply(this, arguments);
        };
    }();
    var _useIdleTimer = useIdleTimer({
        onIdle: onIdle,
        onAction: onAction,
        onActive: onAction,
        timeout: timeout,
        throttle: throttle
    }), activate = _useIdleTimer.activate;
    return /*#__PURE__*/ React.createElement(ErrorBoundary, null, /*#__PURE__*/ React.createElement(ApplicationsProvider, null, /*#__PURE__*/ React.createElement(ConfigProvider, null, /*#__PURE__*/ React.createElement(ThemeDetailsProvider, null, /*#__PURE__*/ React.createElement(ThemeProvider, {
        theme: theme
    }, /*#__PURE__*/ React.createElement(ToastContextProvider, null, /*#__PURE__*/ React.createElement(Routes, null, /*#__PURE__*/ React.createElement(Route, {
        path: ROUTES.HOME,
        element: /*#__PURE__*/ React.createElement(Home, null)
    }), JSON.parse((_process$env$REACT_AP = process.env.REACT_APP_true) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : 'false') && /*#__PURE__*/ React.createElement(Route, {
        path: ROUTES.APPS,
        element: /*#__PURE__*/ React.createElement(Drawer, null, /*#__PURE__*/ React.createElement(PermissionGate, {
            action: RBAC_ACTIONS.RBAC_VIEW_APPLICATION,
            fallback: /*#__PURE__*/ React.createElement(AccessUnavailable, null)
        }, /*#__PURE__*/ React.createElement(ProductSelection, null)))
    }), /*#__PURE__*/ React.createElement(Route, {
        path: ROUTES.PRODUCT,
        element: /*#__PURE__*/ React.createElement(Drawer, null, /*#__PURE__*/ React.createElement(Product, null))
    }), /*#__PURE__*/ React.createElement(Route, {
        path: ROUTES.SETTINGS,
        element: /*#__PURE__*/ React.createElement(Drawer, null, /*#__PURE__*/ React.createElement(PermissionGate, {
            action: ADMIN_ACCESS_ACTIONS,
            fallback: /*#__PURE__*/ React.createElement(AccessUnavailable, null)
        }, /*#__PURE__*/ React.createElement(Settings, null)))
    }), /*#__PURE__*/ React.createElement(Route, {
        path: ROUTES.TERMS_OF_USE,
        element: /*#__PURE__*/ React.createElement(Drawer, null, /*#__PURE__*/ React.createElement(TermsOfUse, null))
    }), /*#__PURE__*/ React.createElement(Route, {
        path: ROUTES.HELP,
        element: /*#__PURE__*/ React.createElement(Drawer, null, /*#__PURE__*/ React.createElement(HelpCenterGuideViewer, null))
    })), /*#__PURE__*/ React.createElement(Toast, null)))))));
}
